<template>
  <div class="hero is-cover is-relative is-theme-secondary blogpost-hero">
    <nav class="navbar navbar-wrapper navbar-fade navbar-light is-transparent">
      <div class="container">
        <!-- Brand -->
        <div class="navbar-brand">
          <a class="navbar-item" href="/">
            <img
              class="light-logo"
              src="https://res.cloudinary.com/nailedd/image/upload/v1584032179/capturefit/logo-black-bg.png"
              alt="CaptureFit"
            />
            <img
              class="dark-logo"
              src="https://res.cloudinary.com/nailedd/image/upload/v1584032179/capturefit/logo-black-bg.png"
              alt="CaptureFit"
            />
          </a>

          <!-- Sidebar Trigger -->
          <a
            id="navigation-trigger"
            class="navbar-item hamburger-btn"
            href="javascript:void(0);"
          >
            <span class="menu-toggle">
              <span class="icon-box-toggle">
                <span class="rotate">
                  <i class="icon-line-top"></i>
                  <i class="icon-line-center"></i>
                  <i class="icon-line-bottom"></i>
                </span>
              </span>
            </span>
          </a>

          <!-- Responsive toggle -->
          <div class="custom-burger" data-target="">
            <a id="" class="responsive-btn" href="javascript:void(0);">
              <span class="menu-toggle">
                <span class="icon-box-toggle">
                  <span class="rotate">
                    <i class="icon-line-top"></i>
                    <i class="icon-line-center"></i>
                    <i class="icon-line-bottom"></i>
                  </span>
                </span>
              </span>
            </a>
          </div>
          <!-- /Responsive toggle -->
        </div>

        <!-- Navbar menu -->
        <div class="navbar-menu">
          <!-- Navbar Start -->
          <div class="navbar-start">
            <div class="navbar-item has-dropdown is-hoverable is-hidden-mobile">
              <a class="navbar-link" href="/events"> Events </a>
              <div class="navbar-dropdown is-boxed is-medium">
                <!-- Dropdown item -->
                <a class="navbar-item is-menu" href="/events">
                  <span>Upcoming</span>
                </a>
                <a class="navbar-item is-menu" href="/past-events">
                  <span>Past</span>
                </a>
                <a
                  class="navbar-item is-menu"
                  href="/host-your-fitness-event-with-us"
                >
                  <span>Create New</span>
                </a>
              </div>
            </div>
            <!-- Mobile dropdown -->
            <div class="mobile-drop is-hidden-desktop is-hidden-tablet">
              <div class="mobile-drop-trigger">
                Events <i class="material-icons">keyboard_arrow_right</i>
              </div>
              <div class="child-menu">
                <ul>
                  <li>
                    <a href="/events">Upcoming</a>
                  </li>
                  <li>
                    <a href="/past-events">Past</a>
                  </li>
                  <li>
                    <a href="/host-your-fitness-event-with-us">Create New</a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="navbar-item has-dropdown is-hoverable is-hidden-mobile">
              <a class="navbar-link" href="/events"> Product </a>
              <div class="navbar-dropdown is-boxed is-medium">
                <!-- Dropdown item -->
                <a class="navbar-item is-menu" href="/about-capturefit">
                  <span>About Us</span>
                </a>
                <a class="navbar-item is-menu" href="/features">
                  <span>Features</span>
                </a>
                <a class="navbar-item is-menu" href="/capturefit-sites">
                  <span>CaptureFit Event Sites</span>
                </a>
              </div>
            </div>
            <!-- Mobile dropdown -->
            <div class="mobile-drop is-hidden-desktop is-hidden-tablet">
              <div class="mobile-drop-trigger">
                Product <i class="material-icons">keyboard_arrow_right</i>
              </div>
              <div class="child-menu">
                <ul>
                  <li>
                    <a href="/about-capturefit">About Us</a>
                  </li>
                  <li>
                    <a href="/features">Features</a>
                  </li>
                  <li>
                    <a href="/free-event-management-toolkit"
                      >FREE Event Management Toolkit</a
                    >
                  </li>
                  <li>
                    <a href="/athlete-prep-guide-series"
                      >FREE Athlete Prep Guide</a
                    >
                  </li>
                  <li>
                    <a href="/blog/capturefit-event-sites"
                      >CaptureFit Event Sites</a
                    >
                  </li>
                </ul>
              </div>
            </div>
            <a class="navbar-item is-slide" href="/blog"> Blog </a>
            <a class="navbar-item is-slide" href="/contact-us"> Contact Us </a>
            <div class="navbar-item has-dropdown is-hoverable is-hidden-mobile">
              <a class="navbar-link" href="/events"> More </a>
              <div class="navbar-dropdown is-boxed is-medium">
                <!-- Dropdown item -->
                <a class="navbar-item is-menu" href="/faq">
                  <span>FAQ</span>
                </a>
                <a class="navbar-item is-menu" href="/app-v2/order-shirts">
                  <span>Order Shirts</span>
                </a>
                <a class="navbar-item is-menu" href="/partners">
                  <span>Our Partners</span>
                </a>
              </div>
            </div>
            <!-- Mobile dropdown -->
            <div class="mobile-drop is-hidden-desktop is-hidden-tablet">
              <div class="mobile-drop-trigger">
                More <i class="material-icons">keyboard_arrow_right</i>
              </div>
              <div class="child-menu">
                <ul>
                  <li>
                    <a href="/faq">FAQ</a>
                  </li>
                  <li>
                    <a href="/app-v2/order-shirts">Order Shirts</a>
                  </li>
                  <li>
                    <a href="/partners">Our Partners</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <!-- Navbar end -->
          <div class="navbar-end">
            <div class="navbar-item">
              <a
                href="/host-your-fitness-event-with-us"
                class="button button-signup btn-outlined is-bold btn-align light-btn rounded raised"
              >
                Request Demo
              </a>
            </div>
            <div class="navbar-item">
              <a
                v-if="!isAuthenticated"
                id="signup-btn"
                href="/app-v2/login"
                class="button button-signup btn-outlined is-bold btn-align light-btn rounded raised"
              >
                Sign up / Login
              </a>
            </div>
            <div class="navbar-item">
              <a
                href="https://www.facebook.com/capturefitco"
                class="navbar-item is-slide"
                target="_blank"
              >
                <span class="icon"
                  ><i class="fa fa-2x fa-facebook-square"></i
                ></span>
              </a>
              <a
                href="https://instagram.com/capturefitco"
                class="navbar-item is-slide"
                target="_blank"
              >
                <span class="icon"><i class="fa fa-2x fa-instagram"></i></span>
              </a>
              <a
                href="https://twitter.com/capturefitco"
                class="navbar-item is-slide"
                target="_blank"
              >
                <span class="icon"><i class="fa fa-2x fa-twitter"></i></span>
              </a>
              <a
                href="https://www.youtube.com/channel/UC4kgk86ky91vuV09COInlbw"
                target="_blank"
                class="navbar-item is-slide"
              >
                <span class="icon"><i class="fa fa-2x fa-youtube"></i></span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["isAuthenticated"]),
  },
};
</script>